import React, { useState } from "react";

import { useQuery, useMutation, STATUS } from "../../../commonjs/fetchHooks";

import { Spinner } from "../../../commonjs/components";
import { useParams } from "react-router-dom";
import {
  AccountApprovalData,
  AccountApprovalDataFailed,
  AccountApprovalDataUserAlreadyDeleted,
  AccountApprovalDataUserAlreadyApproved,
} from "./AccountApprovalData";

import {
  AccountApprovalResult,
  AccountApprovalResultFailed,
} from "./AccountApprovalResult";

const GET_CLIENT_CONFIRMATION = ({ token }) => ({
  endpoint: "accounts:api_client_confirmation",
  data: { query: { token } },
});

const POST_CLIENT_CONFIRMATION = ({ token, approved, feedback }) => ({
  method: "POST",
  endpoint: "accounts:api_client_confirmation",
  data: { body: { token, approved, feedback } },
});

export function ClientConfirm(props) {
  // we are going through two phases:
  // 1. loading and displaying of the user data required for the approval process
  // 2. uploading the user's approval decision and displaying a confirmation page
  // maybe a state machine would make things a bit clearer ...

  const { code } = useParams();
  const [approved, setApproved] = useState(null);
  const {
    data,
    status: statusLoad,
    error,
  } = useQuery(GET_CLIENT_CONFIRMATION, {
    token: code,
  });
  const [mutate, { status: statusUpload }] = useMutation(
    POST_CLIENT_CONFIRMATION
  );

  const handleApproval = (approved, feedback) => {
    setApproved(approved);
    mutate({ token: code, approved, feedback });
  };

  // handle user data loading (phase 1)
  if (statusLoad === STATUS.IDLE || statusLoad === STATUS.PENDING) {
    return <Spinner />;
  }

  if (statusLoad === STATUS.REJECTED) {
    if (error.user_deleted) {
      return <AccountApprovalDataUserAlreadyDeleted />;
    } else return <AccountApprovalDataFailed />;
  }

  // here we are sure that user data loading was successfull (statusLoad === STATUS.RESOLVED)

  // check for feedback in phase 2
  if (statusUpload === STATUS.REJECTED) {
    return <AccountApprovalResultFailed />;
  }

  if (statusUpload === STATUS.RESOLVED) {
    return <AccountApprovalResult approved={approved} />;
  }

  if (["CS_APPROVAL_REQUESTED", "APPROVED"].includes(data.state)) {
    return <AccountApprovalDataUserAlreadyApproved />;
  }

  // here we are sure that phase 2 has not been started yet (idle) or is running (pending)

  // show the user data
  return <AccountApprovalData data={data} onApproval={handleApproval} />;
}
